import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Container, Dropdown, Grid, Icon} from 'semantic-ui-react';
import isEmpty from 'lodash/isEmpty';
import negate from 'lodash/negate';
import {injectIntl, intlShape} from 'react-intl';
import {EmptyFunc, mapPropsToDropdownItems} from 'utils/DBUtils';
import CreateBreakButton from "pages/BreakCreator/CreateBreakButton";

const FilterBar = props => {
  const activeFilters = props.namedFilters.filter(props.hasNamedFilter);
  const allowClearAll = activeFilters.length > 0;
  const dropdownOptions = mapPropsToDropdownItems(props);
  const disableDropdown = !dropdownOptions.filter(negate(isEmpty)).length;

  return (
    <Container className="filter-bar">
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column width={10} className="filter-group">
            {activeFilters.map(filter => {
              const message = props.intl.formatMessage({ id: 'filter.' + filter });
              const className = classnames('animResponse fadeInDown', {
                'filter-wrap': message.length > 8
              });

              return (
                <span key={filter} className={className}>
                  {message}
                  <Icon onClick={() => props.onFilterDeselected(filter)} name="close" />
                </span>
              );
            })}
          </Grid.Column>
          <Grid.Column width={3} className="filter-bar-dd">
            {allowClearAll && (
              <span className="animResponse fadeInDown filter-bar-clearAll">
                {props.intl.formatMessage({ id: 'filter.clearAll' })}
                <Icon onClick={props.clearAllFilters} name="close" />
              </span>
            )}
            <Dropdown
              text="Select filter"
              className="db-filter-dropdown"
              fluid
              selection
              closeOnChange
              closeOnBlur
              openOnFocus={false}
              disabled={disableDropdown}>
              <Dropdown.Menu>{dropdownOptions}</Dropdown.Menu>
            </Dropdown>
          </Grid.Column>
          <Grid.Column width={3}>
            <CreateBreakButton/>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};

export const propShape = {
  namedFilters: PropTypes.arrayOf(PropTypes.string),
  filterGroups: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  hasNamedFilter: PropTypes.func,
  onFilterSelected: PropTypes.func,
  onFilterDeselected: PropTypes.func,
  clearAllFilters: PropTypes.func
};

FilterBar.propTypes = propShape;

FilterBar.defaultProps = {
  intl: intlShape,
  namedFilters: [],
  filterGroups: [],
  hasNamedFilter: EmptyFunc,
  onFilterSelected: EmptyFunc,
  onFilterDeselected: EmptyFunc,
  clearAllFilters: EmptyFunc
};

export default injectIntl(FilterBar);



// WEBPACK FOOTER //
// ./public/components/common/FilterBar.jsx